// extracted by mini-css-extract-plugin
module.exports = {"root":"classes_root__2g2sr","title":"classes_title__1ETyo"};